<template>
    <div>
        <template v-if="!$vuetify.display.mobile && syncedInDialog === null" class="pb-2">
            <v-row no-gutters v-if="splitUserPartitions">
                <v-col class="d-flex align-center v-col-auto pr-3 title"> Etiquettes </v-col>
                <v-col class="d-flex align-center">
                    <v-divider />
                </v-col>
                <v-col class="d-flex align-center v-col-auto pl-3 title" v-if="isExpandable">
                    <v-btn-icon :icon="expanded ? '$remove' : '$add'" @click="expanded = !expanded">
                    </v-btn-icon>
                </v-col>
            </v-row>
            <v-combobox
                v-model="model"
                :filter="filter"
                :hide-no-data="!search"
                :items="filteredCompanyTags"
                v-model:search-input="search"
                hide-selected
                variant="underlined"
                placeholder="Sélectionner ou créer une étiquette"
                multiple
                v-if="!splitUserPartitions || !expanded"
                hide-details
                item-value="id"
                item-title="text"
                single-line
                @update:focused="onFocus"
                :readonly="!currentUser.profile || !currentUser.profile.configuration.tag.write"
                prepend-inner-icon="$label_outline"
            >
                <!-- :style="{
                    padding: '0 0 4px 0',
                    height: '35px',
                    overflow: 'hidden',
                    'white-space': 'nowrap',
                    width: '100%',
                    'box-sizing': 'border-box',
                    'border-radius': '8px',
                    'margin-bottom': '4px',
                }" -->

                <template v-slot:no-data>
                    <v-list-item class="oss-list-item">
                        <span class="subheading">Créer</span>
                        <v-chip class="ml-1" color="tagFree" size="small">{{ search }}</v-chip>
                    </v-list-item>
                </template>
                <!-- <template v-slot:prepend>
                    <v-chip :color="`${accountableTag.color} lighten-3`" :selected="selected" label size="small">
                        <span class="pr-2">{{accountableTag.name}}</span>
                    </v-chip>
                </template> -->
                <template v-slot:selection="{ item, index }">
                    <v-chip
                        v-if="item === Object(item)"
                        :color="`${item.raw.color}`"
                        :variant="item.raw.type === 'SubAccountableAccount' ? 'outlined' : 'flat'"
                        text-color="black"
                        size="small"
                        label
                    >
                        <v-icon
                            density="compact"
                            size="x-small"
                            class="pr-2"
                            v-if="
                                item.raw.partitionTag && item.raw.partitionTag.type === 'Building'
                            "
                            >$fa-building</v-icon
                        >
                        <span>{{ getTagName(item.raw) }}</span>
                        <v-icon
                            size="small"
                            @click="
                                tagGate();
                                removeItemWithIndex(index);
                            "
                            v-if="isRemoveable(item.raw)"
                            class="ml-2"
                            >$close</v-icon
                        >
                    </v-chip>
                </template>
                <template v-slot:item="{ index, item, props }">
                    <v-list-item
                        v-bind="props"
                        :style="{
                            minHeight: '30px',
                            pointerEvents: item.raw.header ? 'none' : 'auto',
                        }"
                    >
                        <template #title />
                        <v-text-field
                            v-if="editing === item.raw"
                            v-model="editing.text"
                            autofocus
                            text
                            background-color="transparent"
                            hide-details
                            solo
                            @keyup.enter="edit(index, item.raw)"
                            class="text_field_tag"
                        />
                        <template v-else-if="item.raw.header">
                            <span
                                class="text-subtitle-2 text-medium-emphasis"
                                style="color: black"
                                >{{ item.raw.header }}</span
                            >
                        </template>
                        <v-chip
                            v-else
                            :color="`${item.raw.color}`"
                            :variant="
                                item.raw.type === 'SubAccountableAccount' ? 'outlined' : 'flat'
                            "
                            size="small"
                            label
                        >
                            <v-icon
                                dense
                                size="x-small"
                                class="pr-2"
                                v-if="
                                    item.raw.partitionTag &&
                                    item.raw.partitionTag.type === 'Building'
                                "
                            >
                                $fa-building
                            </v-icon>
                            <span>{{ getTagNameToSelect(item.raw) }}</span>
                        </v-chip>
                    </v-list-item>
                    <!-- <v-spacer></v-spacer> -->
                    <!-- <template v-slot:append @click.stop>
                        <v-btn rounded="circle" size="small" @click.stop.prevent="edit(index, item)" v-if="isEditable(item)" class="back_btn_tag">
                            <v-icon>{{ editing !== item ? 'edit' : 'check' }}</v-icon>
                        </v-btn>
                    </template> -->
                </template>
                <template v-slot:prepend-item>
                    <v-row no-gutters>
                        <v-col cols="12" class="d-flex justify-end px-2">
                            <v-icon color="secondary" size="small" @click="dialogTagManager = true"
                                >$fa-gear</v-icon
                            >
                        </v-col>
                    </v-row>
                </template>
            </v-combobox>
            <template v-if="visiblePartitions.length">
                <v-container>
                    <v-row
                        v-for="(partitionTag, index) in partitionTags"
                        :key="index"
                        class="align-center mb-2"
                        no-gutters
                    >
                        <v-col
                            cols="5"
                            class="d-flex align-center"
                            v-if="partitionTag.partitionTag.name !== 'OtherPartition'"
                        >
                            <span class="mr-2">{{ partitionTag.partitionTag.name }}</span>
                        </v-col>
                        <v-col :cols="partitionTag.partitionTag.name !== 'OtherPartition' ? 7 : 12">
                            <v-combobox-filled
                                v-model="partitionTag.model"
                                :filter="filter"
                                :hide-no-data="!partitionTag.search"
                                :items="partitionTag.tags"
                                v-model:search-input="partitionTag.search"
                                hide-selected
                                label="Sélectionner ou créer une étiquette"
                                multiple
                                :class="{ 'v-text-field--outlined': outlined }"
                                :style="{
                                    padding: '0 0 4px 0',
                                    height: '40px',
                                    overflow: 'hidden',
                                    'white-space': 'nowrap',
                                    width: '100%',
                                    'box-sizing': 'border-box',
                                    'border-radius': '8px',
                                }"
                                density="compact"
                                hide-details
                                item-value="id"
                                item-title="text"
                                single-line
                                @update:focused="onFocus"
                                :readonly="
                                    !currentUser.profile ||
                                    !currentUser.profile.configuration.tag.write
                                "
                                :background-color="'#FAFAFA'"
                                @update:model-value="onPartitionTagChanged(partitionTag)"
                            >
                                <template v-slot:no-data>
                                    <v-list-item class="oss-list-item">
                                        <span class="subheading">Créer</span>
                                        <v-chip class="ml-1" color="tagFree" size="small">
                                            {{ partitionTag.search }}
                                        </v-chip>
                                    </v-list-item>
                                </template>
                                <template v-slot:selection="{ item, index }">
                                    <v-chip
                                        v-if="item === Object(item)"
                                        :color="`${item.raw.color}`"
                                        :variant="
                                            item.raw.type === 'SubAccountableAccount'
                                                ? 'outlined'
                                                : 'flat'
                                        "
                                        text-color="black"
                                        :model-value="true"
                                        size="small"
                                        label
                                    >
                                        <v-icon
                                            density="compact"
                                            size="x-small"
                                            class="pr-2"
                                            v-if="
                                                partitionTag.partitionTag &&
                                                partitionTag.partitionTag.type === 'Building'
                                            "
                                            >$fa-building</v-icon
                                        >
                                        <span class="pr-2">{{ getTagName(item.raw) }}</span>
                                        <v-icon
                                            size="x-small"
                                            @click="(tagGate(), removeItemWithIndex(index))"
                                            v-if="isRemoveable(item)"
                                            class="ml-2"
                                            >$close</v-icon
                                        >
                                    </v-chip>
                                </template>
                                <template v-slot:item="{ index, item, props }">
                                    <v-list-item v-bind="props">
                                        <template #title />
                                        <v-text-field
                                            v-if="editing === item"
                                            v-model="editing.text"
                                            autofocus
                                            text
                                            background-color="transparent"
                                            hide-details
                                            solo
                                            @keyup.enter="edit(index, item)"
                                            class="text_field_tag"
                                        />
                                        <v-chip
                                            v-else
                                            :color="`${item.raw.color}`"
                                            :variant="
                                                item.raw.type === 'SubAccountableAccount'
                                                    ? 'outlined'
                                                    : 'flat'
                                            "
                                            text-color="black"
                                            label
                                            size="small"
                                            >{{ getTagNameToSelect(item.raw) }}</v-chip
                                        >
                                    </v-list-item>
                                </template>
                                <template v-slot:prepend-item>
                                    <v-row no-gutters>
                                        <v-col cols="12" class="d-flex justify-end px-2">
                                            <v-icon
                                                color="secondary"
                                                size="small"
                                                @click="dialogTagManager = true"
                                                >$fa-gear</v-icon
                                            >
                                        </v-col>
                                    </v-row>
                                </template>
                            </v-combobox-filled>
                        </v-col>
                    </v-row>
                </v-container>
            </template>
        </template>
        <template v-else>
            <v-text-field-filled
                @click="dialog = true"
                :label="model.length ? '' : 'Etiquettes'"
                hide-details
                v-show="syncedInDialog === null"
                height="20px"
                density="compact"
            >
                <div class="d-flex align-center" style="flex-wrap: wrap">
                    <template v-for="tag in model" :key="tag.name">
                        <v-chip
                            :color="`${tag.color}`"
                            :input-value="tag.name"
                            size="small"
                            label
                            class="ma-1"
                            variant="flat"
                        >
                            <v-icon
                                dense
                                size="x-small"
                                class="pr-2"
                                v-if="tag.partitionTag && tag.partitionTag.type === 'Building'"
                                >$fa-building</v-icon
                            >
                            <span class="pr-2">{{ getTagName(tag) }}</span>
                            <v-icon
                                size="small"
                                @click.stop="(tagGate(), removeItem(tag))"
                                v-if="isRemoveable(tag)"
                                >$close</v-icon
                            >
                        </v-chip>
                    </template>
                </div>
            </v-text-field-filled>
            <oss-dialog
                v-model="dialog"
                :fullscreen="syncedInDialog === null"
                hide-overlay
                title="Etiquettes"
            >
                <div class="w-100 d-flex flex-column">
                    <v-row no-gutters>
                        <v-col cols="9" class="pt-1 pb-3">
                            <v-text-field-filled
                                v-model="searchText"
                                autofocus
                                text
                                label="Recherche"
                                @keyup.enter="addNewTag()"
                                density="compact"
                            />
                        </v-col>
                        <v-col cols="3" class="pl-2 text-right d-flex align-center justify-end">
                            <v-btn
                                elevation="0"
                                rounded
                                :disabled="!searchText"
                                @click="addNewTag()"
                                :loading="addNewTagLoading"
                                size="x-small"
                            >
                                {{ tagExists() ? "Ajouter" : "Choisir" }}
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-divider class="mx-3" />
                    <v-row no-gutters style="height: calc(90vh - 171px); overflow-y: auto">
                        <v-col cols="12" v-for="tag in filteredAllCompanyTags" :key="tag.id">
                            <div v-if="tag.header" class="pt-3 pb-2">
                                <strong>{{ tag.header }}</strong>
                            </div>
                            <v-row no-gutters v-else @click="addTag(tag)" class="py-1">
                                <v-col cols="9">
                                    <v-chip variant="flat" :color="`${tag.color}`" size="small">
                                        <v-icon
                                            dense
                                            size="x-small"
                                            class="pr-2"
                                            v-if="
                                                tag.partitionTag &&
                                                tag.partitionTag.type === 'Building'
                                            "
                                            >$fa-building</v-icon
                                        >
                                        <span>{{ getTagNameToSelect(tag) }}</span></v-chip
                                    >
                                </v-col>
                                <v-col cols="3" class="pl-2 d-flex align-center justify-end">
                                    <v-btn
                                        elevation="0"
                                        rounded
                                        :loading="addTagLoading"
                                        size="x-small"
                                    >
                                        Choisir
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <v-divider />
                        </v-col>
                    </v-row>
                </div>
            </oss-dialog>
        </template>
        <v-snackbar
            v-model="snackbar.display"
            multi-line
            :timeout="15000"
            absolute
            width="auto"
            max-width="none"
            style="position: fixed; margin-top: 64px"
            location="top end"
        >
            <strong>{{ snackbarText }}</strong>

            <template v-slot:actions>
                <v-btn @click.stop="createOneSuggestion()" variant="text"> Appliquer </v-btn>
                <v-btn-icon icon="$oss-close" size="small" @click.stop="snackbar.display = false" />
            </template>
        </v-snackbar>
        <oss-dialog
            title="Gérer vos étiquettes et journaux"
            v-model="dialogTagManager"
            v-if="dialogTagManager"
        >
            <tag-manager> </tag-manager>
        </oss-dialog>
    </div>
</template>

<script lang="ts">
import { FreeTagBase } from "./FreeTagBase";
import TagManager from "./TagManager.vue";
import { Component, Vue, toNative } from "vue-facing-decorator";

@Component({
    components: {
        TagManager,
    },
})
export class FreeTag extends FreeTagBase {
    async createOneSuggestion() {
        await this.createSuggestion(this.snackbar);
    }
}

export default toNative(FreeTag);
</script>
<style lang="scss">
.v-list-item {
    min-height: 30px;
}

.v-subheader {
    font-weight: 600;
    height: auto;
}

.v-autocomplete.v-input > .v-input__control > .v-input__slot {
    padding-left: 2px !important;
    padding-right: 6px !important;
}
</style>
